import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Loader from "../../../Loader";
import { T } from '../../../../utils/I18n/I18n';
import { useQuery } from "@apollo/react-hooks";
import { GET_ORDERBOOK } from "../orderbookQuery";
import useResponsive from "../../../../hooks/useResponsive";
import { useCartContext } from "../../../../context/CartContext";
import AddressPresentation from "../../PersonalAreaAddress/ShowAddress/AddressPresentation";

const Shipment = () => {
    const navigate = useNavigate(); // Poprawiono nazwę z 'history' na 'navigate'
    const { loading, error, data, refetch } = useQuery(GET_ORDERBOOK);
    const params = useParams();
    const { isMobile } = useResponsive();
    const [items, setItems] = useState([]);
    const { handleProductAdd } = useCartContext();

    // useEffect zawsze wywoływany na najwyższym poziomie
    useEffect(() => {
        if (!error && !loading && data) {
            const order = data.customerOrderbook.orders.items.find(({ id }) => id === params.ordersDetailsId);
            setItems(order || []);
            refetch();
        }
    }, [data, error, loading, refetch, params.ordersDetailsId]);

    const addProductsToCart = () => {
        if (items.items) {
            items.items.forEach(({ product_sku, quantity_ordered }) => {
                handleProductAdd(product_sku, quantity_ordered);
            });
            navigate("/checkout/cart");
        }
    };

    if (error) {
        return <h1>{error.message}</h1>;
    }

    return (
        <div className="orders-details">
            {loading && <Loader />}
            {!loading && !data && <h3>Podaci se nisu učitali, probajte ponovno</h3>}

            {items.number && (
                <div className="orders-details__content">
                    <h1>
                        <T id="personalArea.oneOrder" /> # {items.number}
                    </h1>
                    <h3>
                        <T id="orders.orderStatus" /> {items.status}
                    </h3>
                    <div className="orders-details__content__header-text">
                        <p>
                            <T id="orders.orderDate" />: {items.order_date}
                        </p>
                        <p onClick={addProductsToCart}>
                            <a href="#">
                                <T id="orders.repeatOrder" />
                            </a>
                        </p>
                        <p>
                            <a href="#" onClick={() => window && window.print()}>
                                <T id="orders.printOrder" />
                            </a>
                        </p>
                        <p>
                            <Link to={`/customer/account/orders/${params.ordersDetailsId}`}>
                                <T id="orders.orderedProducts" />
                            </Link>
                        </p>
                        {items.invoices?.[0] && (
                            <p>
                                <Link to={`/customer/account/orders/invoice/${params.ordersDetailsId}`}>
                                    <T id="personalArea.receipt" />
                                </Link>
                            </p>
                        )}
                        {items.credit_memos?.[0] && (
                            <p>
                                <Link to={`/customer/account/orders/creditmemo/${params.ordersDetailsId}`}>
                                    <T id="orders.refund" />
                                </Link>
                            </p>
                        )}
                        <p className="isBold">
                            <T id="orders.shipment" />
                        </p>
                    </div>

                    <div className="orders-details__content__table">
                        <table>
                            {!isMobile && (
                                <thead>
                                <tr>
                                    <th><T id="orders.productName" /></th>
                                    <th><T id="product.code" /></th>
                                    <th>
                                        <T id="orders.delivered" /> <T id="cart.quantity" />
                                    </th>
                                </tr>
                                </thead>
                            )}

                            {items.shipments?.[0]?.items &&
                                items.shipments[0].items.map(({ product_name, product_sku, quantity_shipped }) => (
                                    <tbody key={product_sku}>
                                    <tr>
                                        <td className="orders-details__content__table__product-name">
                                            {isMobile && <span className="margin-span"><T id="orders.productName" />:</span>}
                                            {product_name}
                                        </td>
                                        <td>
                                            {isMobile && <span className="margin-span"><T id="product.code" />:</span>}
                                            {product_sku}
                                        </td>
                                        <td>
                                            <p>
                                                {isMobile && <span className="margin-span"><T id="cart.quantity" />:</span>}
                                                {quantity_shipped}
                                            </p>
                                        </td>
                                    </tr>
                                    </tbody>
                                ))}
                        </table>

                        <div className="orders-details__content__go-back-btn">
                            <Link to="/customer/account/orders"><T id="orders.goBack" /></Link>
                        </div>

                        {items.shipping_address && (
                            <div className="orders-details__content__addresses">
                                <h2><T id="orders.orderInfo" /></h2>
                                <div className="orders-details__content__addresses-shipping">
                                    <div className="orders-details__content__addresses-shipping-address">
                                        {items.shipping_address ? (
                                            <AddressPresentation address={items.shipping_address} isOrdersbook />
                                        ) : (
                                            <p className="address__no-info"><T id="address.noInfo" /></p>
                                        )}
                                    </div>
                                </div>
                                <div className="orders-details__content__addresses-shipping">
                                    <div className="orders-details__content__addresses-shipping-address">
                                        {items.billing_address ? (
                                            <AddressPresentation address={items.billing_address} addressType="naplatu" isOrdersbook />
                                        ) : (
                                            <p className="address__no-info"><T id="address.noInfo" /></p>
                                        )}
                                    </div>
                                    <div className="orders-details__content__addresses-shipping-delivery">
                                        <p><strong><T id="orders.paymentMethod" /></strong></p>
                                        <p>{items.payment_methods[0].name}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Shipment;